import React, { useState } from "react";
import Order from "../Order/Order";
import "./Ordini.css";

//import OkPopup from "../OkPopup";

const ProfileOrderList = (props) => {
  const [OrderList, setOrderList] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [showDetails, setShowDetails] = useState(null);
/*
  function convert(num) {
    //console.log(num);
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    //return num;
  }
*/
  if (OrderList === null && !IsLoading) {
    getUserOrderList();
  }

  function getUserOrderList() {
    let params = [
      {
        name: "id_e_user",
        value: props.userData ? props.userData.id_e_user.toString() : "0",
      },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/listaOrdiniCliente",
      IsLoading,
      setIsLoading,
      netError,
      () => {
        setOrderList([]);
      },
      params,
      (respData) => {
          if (respData.status === true)
            setOrderList(respData.data);
        else
            setNetError("Spiacenti, si è verificato un problema. " + respData.message);
        //console.log(respData);
      }
    );
  }

  //console.log(OrderList);

  return (
    <div>
      {IsLoading === true ? (
        <div className="spinner">
          <img src="/images/waiting.gif" alt="loading..." />
        </div>
      ) : netError !== null ? (
        <p>{netError}</p>
      ) : showDetails !== null ? (
        <>
          <div className="riga_chiudi_ordine_utente">
            <div
              className="chiudi_ordine_utente"
              onClick={() => setShowDetails(null)}
            >
              <div className="chiudi_ordine_utente_img">
                <img src="/images/torna_utente_on.svg" alt="loading..." />
              </div>
              <p>Torna agli ordini</p>
            </div>
          </div>
          <Order
            order={showDetails.ordine}
            items={showDetails.ordine_prodotti}
            paymentUrls={null}
            fullMode={false}
            convert={props.convert}
          />
          <div className="riga_chiudi_ordine_utente">
            <div
              className="chiudi_ordine_utente"
              onClick={() => setShowDetails(null)}
            >
              <div className="chiudi_ordine_utente_img">
                <img src="/images/torna_utente_on.svg" alt="loading..." />
              </div>
              <p>Torna agli ordini</p>
            </div>
          </div>
        </>
      ) : OrderList !== null ? (
        <div>
          <div className="legenda_lista_ordini">
            <div className="legenda_codice_lista_ordini">
              <p>N. Ordine</p>
            </div>
            <div className="legenda_data_lista_ordini">
              <p>Data Ordine</p>
            </div>
            <div className="legenda_stato_lista_ordini">
              <p>Stato</p>
            </div>
            <div className="legenda_totale_lista_ordini">
              <p>Totale</p>
            </div>
            <div className="legenda_tracking_lista_ordini">
              <p>Tracking</p>
            </div>
            <div className="legenda_dettagli_lista_ordini">
              <p>&nbsp;</p>
            </div>
          </div>
          <div className="AW-clear" />
          {OrderList.map((el, i) => (
            <div className="riga_ordine_profilo" key={"ad_" + i}>
              <div className="codice_ordine">
                <span>N. Ordine:&nbsp;</span>
                {el.ordine.codice_ordine}
              </div>
              <div className="data_ordine">
                <span>Data:&nbsp;</span>
                {el.ordine.data_ordine_str}
              </div>
              <div className="stato_ordine">
                <span>Stato:&nbsp;</span>
                {el.ordine.id_stato_str}
              </div>
              <div className="totale_ordine">
                <span>Totale:&nbsp;</span>
                {props.convert(el.ordine.totale)} &euro;
              </div>
              <div className="tracking_ordine">
                <span>Tracking:&nbsp;</span>
                {el.ordine.tracking}
              </div>
              <div
                className="dettagli_ordine"
                onClick={() => setShowDetails(el)}
              >
                <p>Dettagli</p>
              </div>
              <div className="clear" />
            </div>
          ))}
        </div>
      ) : <p>Nessun ordine presente</p>}
    </div>
  );
};

export default ProfileOrderList;